export const SESSION_MODE_DETAILS = {
    interview: {
        label: "Interview",
        shortLabel: "Interview",
        description: "Behavioral, technical, and phone-screen coaching in real time.",
        startLabel: "Start Interview",
    },
    meeting: {
        label: "Meeting",
        shortLabel: "Meeting",
        description: "Live help for client calls, stakeholder syncs, and internal meetings.",
        startLabel: "Start Meeting",
    },
};
export const SESSION_MODE_ORDER = ["interview", "meeting"];
export const PRICING = {
    currency: "USD",
    symbol: "$",
    // Sticker prices.
    monthly: 59.99,
    yearly: 575.19,
    // yearly / 12 — effective monthly cost when billed annually.
    monthlyEquivalent: 47.93,
    // monthly * 12 — the annual "list" cost, shown struck-through against `yearly`.
    yearlyIfBilledMonthly: 719.88,
    // yearlyIfBilledMonthly - yearly.
    yearlySavings: 144.69,
    savingsPercent: 20,
};
// Everything the single Professional plan includes. One flat, unlimited plan —
// no usage credits, no token caps, no locked features.
export const PROFESSIONAL_FEATURES = [
    "Live interview copilot on desktop",
    "Live meeting copilot on desktop",
    "Real-time transcript (You / Them)",
    "Screen-aware answers on desktop",
    "Coding help from what is on screen",
    "Meeting notes: summary, decisions, actions",
    "PDF export of notes",
    "Resume, job description, and document context",
    "Searchable session history",
    "macOS desktop app",
    "Windows desktop app",
    "Web account, billing, and download",
    "Overlay hidden from screen share",
];
export const PROFESSIONAL_PLAN = {
    id: "professional",
    name: "Professional",
    monthly: PRICING.monthly,
    yearly: PRICING.yearly,
    features: PROFESSIONAL_FEATURES,
};
//# sourceMappingURL=index.js.map